import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolStatusSelectorViewModel extends SelectorBaseViewModel<ToolStatus> {
    constructor(parentViewModel: ViewModel, id: string = null) {
        super(parentViewModel, true);
        this.toolModelId = id;
    }

    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;

    protected async loadData(): Promise<ToolStatus[]> {
        if (this.toolModelId != null) {
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/GetToolModelValidStatuses', {
                ToolModelId: this.toolModelId
            });
            return result.StatusList.map(x => {
                let t = new ToolStatus(this);
                t.id = x.ToolModelStatusId;
                t.title = `${x.Name} (${x.Code})`;
                return t;
            });
        }
        return [];
    }
}

export class ToolStatus extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}